import { IDs } from '../../../../helpers/IDs';

export class Formulare {

    protected static groups: string[] = [
        'Energiedaten',
        'Scope 3',
        'Erneuerbare Energien',
        'Zusatztools',
        'Admin'
    ];
    public static entities: any[] = [
        { id: IDs.ENT_ENERGIEDATEN_STROM, module: IDs.MOD_ETOOL, group: Formulare.groups[0] },
        { id: IDs.ENT_ENERGIEDATEN_EIGENSTROM, module: IDs.MOD_ETOOL, group: Formulare.groups[0] },
        { id: IDs.ENT_ENERGIEDATEN_WAERME, module: IDs.MOD_ETOOL, group: Formulare.groups[0] },
        { id: IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE, module: IDs.MOD_ETOOL, group: Formulare.groups[0] },
        { id: IDs.ENT_ENERGIEDATEN_WASSER, module: IDs.MOD_ETOOL, group: Formulare.groups[0] },
        { id: IDs.ENT_KLIMAGASE, module: IDs.MOD_ETOOL, group: Formulare.groups[0] },
        { id: IDs.ENT_KENNZAHLEN_DYNAMISCH, module: IDs.MOD_ETOOL, group: Formulare.groups[0] },
        { id: IDs.ENT_BETRIEBSDATEN, module: IDs.MOD_ETOOL, group: Formulare.groups[0] },
        { id: IDs.ENT_SONSTIGE_DATEN, module: IDs.MOD_ETOOL, group: Formulare.groups[0] },
        { id: IDs.ENT_MASCHINEN, module: IDs.MOD_ETOOL, group: '...' },
        { id: IDs.ENT_FAHRZEUGE, module: IDs.MOD_ETOOL, group: '...' },
        { id: IDs.ENT_GALLERY, module: IDs.MOD_ETOOL, group: '...' },
        { id: IDs.ENT_EINZELMASSNAHMEN, module: IDs.MOD_ETOOL, group: '...' },
        { id: IDs.ENT_MASSNAHMEN, module: IDs.MOD_ETOOL, group: Formulare.groups[3] },
        { id: IDs.ENT_LASTGANG, module: IDs.MOD_ETOOL, group: Formulare.groups[3] },
        { id: IDs.ENT_ANLAGEN_EIGENSTROM_KWK, module: IDs.MOD_ETOOL, group: Formulare.groups[2] },
        { id: IDs.ENT_ANLAGEN_EIGENSTROM_PHOTOVOLTAIK, module: IDs.MOD_ETOOL, group: Formulare.groups[2] },
        { id: IDs.ENT_ANLAGEN_EIGENSTROM_WINDKRAFT, module: IDs.MOD_ETOOL, group: Formulare.groups[2] },
        { id: IDs.ENT_ANLAGEN_EIGENSTROM_BIOMASSE, module: IDs.MOD_ETOOL, group: Formulare.groups[2] },
        { id: IDs.ENT_ANLAGEN_EIGENSTROM_SOLARTHERMIE, module: IDs.MOD_ETOOL, group: Formulare.groups[2] },
        { id: IDs.ENT_ANLAGEN_EIGENSTROM_WAERMEPUMPEN, module: IDs.MOD_ETOOL, group: Formulare.groups[2] },
        { id: IDs.ENT_ANGEMIETETE_RAEUMLICHKEITEN, module: IDs.MOD_ETOOL, group: Formulare.groups[0] },
        { id: IDs.ENT_ANGEMIETETE_FAHRZEUGE, module: IDs.MOD_ETOOL, group: Formulare.groups[0] },
        { id: IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF, module: IDs.MOD_ETOOL, group: Formulare.groups[1] },
        { id: IDs.ENT_CO2_SCOPE3_GUETER_KAPITAL, module: IDs.MOD_ETOOL, group: Formulare.groups[1] },
        { id: IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT, module: IDs.MOD_ETOOL, group: Formulare.groups[1] },
        { id: IDs.ENT_CO2_SCOPE3_ABFALL, module: IDs.MOD_ETOOL, group: Formulare.groups[1] },
        { id: IDs.ENT_CO2_SCOPE3_REISEN, module: IDs.MOD_ETOOL, group: Formulare.groups[1] },
        { id: IDs.ENT_CO2_SCOPE3_PENDELN, module: IDs.MOD_ETOOL, group: Formulare.groups[1] },
        { id: IDs.ENT_CO2_SCOPE3_PENDELN_KAMPAGNE, module: IDs.MOD_ETOOL, group: Formulare.groups[1] },
        { id: IDs.ENT_CO2_SCOPE3_ANGEMIETETE_SACHANLAGEN, module: IDs.MOD_ETOOL, group: Formulare.groups[1] },
        { id: IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT, module: IDs.MOD_ETOOL, group: Formulare.groups[1] },
        { id: IDs.ENT_ANABREISE, module: IDs.MOD_ETOOL, group: Formulare.groups[1] },
        { id: IDs.ENT_CO2_SCOPE3_PRODUKTE_VERARBEITUNG, module: IDs.MOD_ETOOL, group: Formulare.groups[1] },
        { id: IDs.ENT_CO2_SCOPE3_PRODUKTE_NUTZUNG, module: IDs.MOD_ETOOL, group: Formulare.groups[1] },
        { id: IDs.ENT_CO2_SCOPE3_PRODUKTE_LEBENSZYKLUS, module: IDs.MOD_ETOOL, group: Formulare.groups[1] },
        { id: IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN, module: IDs.MOD_ETOOL, group: Formulare.groups[1] },
        { id: IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN_RAEUMLICHKEITEN, module: IDs.MOD_ETOOL, group: Formulare.groups[1] },
        { id: IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN_FAHRZEUGE, module: IDs.MOD_ETOOL, group: Formulare.groups[1] },
        { id: IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN_TECHNIK, module: IDs.MOD_ETOOL, group: Formulare.groups[1] },
        { id: IDs.ENT_CO2_SCOPE3_FRANCHISE, module: IDs.MOD_ETOOL, group: Formulare.groups[1] },
        { id: IDs.ENT_CO2_SCOPE3_INVESTITION, module: IDs.MOD_ETOOL, group: Formulare.groups[1] },
        { id: IDs.ENT_CO2_SCOPE3_EMITTENTEN, module: IDs.MOD_ETOOL, group: Formulare.groups[1] },
        { id: IDs.ENT_GLOSSAR, module: IDs.MOD_ETOOL_ADMIN, group: Formulare.groups[4] },
        { id: IDs.ENT_SYSTEMTEXTE, module: IDs.MOD_ETOOL_ADMIN, group: Formulare.groups[4] }
    ];
}
